// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"17c44811","267":"f677aa02","279":"a5d9ce20","421":"4f40942c","433":"a0abdea0","487":"9de9147d","718":"9253b82b","760":"b8e8d4c7","774":"999c1785","937":"102eba4c","995":"6a3b3827"}[chunkId] + ".chunk.js";
};